<template>
  <b-card no-body>
    <b-row align-v="start">
      <b-col>
        <span class="d-flex">
          <h4 class="pl-1 pt-1">
            {{ title }}
          </h4>
          <b-button size="sm" variant="outline-dark" class="xs my-1 ml-2" @click.prevent="$bvModal.show(`call-op`)"
            ><i class="fa fa-lg fa-plus-circle"></i
          ></b-button>
          <call-op-modal :id="`call-op`" :items="items" @ok="handleOk"></call-op-modal>
        </span>
      </b-col>
      <b-col> </b-col>
    </b-row>
    <b-table striped hover :items="items" small :fields="fields">
      <template #cell(progress)="data">
        <b-progress
          :value="data.item.progress ? (data.item.progress >= 100 ? 100 : data.item.progress) : 0"
          max="100"
          show-progress
          :animated="data.item.progress < 100"
          :variant="getBadgeColor(data.item.progress)"
          v-if="data.item.progress > 1"
        ></b-progress>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import CallOpModal from "./CallOpModal";
export default {
  name: "OpList",
  components: {
    CallOpModal
  },
  data() {
    return {
      opOptions: [],
      fields: [
        { key: "id", label: "#" },
        { key: "container.name", label: "Formato" },
        { key: "delivery_date", label: "Fecha entrega" },
        { key: "kilograms", label: "Kgs" },
        { key: "quantity", label: "Q" },
        { key: "completed_boxes", label: "Completado" },
        { key: "selected_boxes", label: "Seleccionado" },
        { key: "remaining_boxes", label: "Restante" },
        { key: "progress", label: "%" }
      ]
    };
  },
  props: {
    title: {
      type: String,
      default: "-"
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleOk(val) {
      this.$emit("ok", val);
    },
    getBadgeColor(percentage) {
      // vigente, cancelado, completado
      if (percentage >= 100) {
        return "success";
      } else if (percentage < 100 && percentage > 0) {
        return "primary";
      } else {
        return "danger";
      }
    }
  }
};
</script>

<style scoped>
.btn-sm.xs {
  padding: 0.1rem 0.4rem;
}
</style>
